<div class="bg-m0 flex-grow select-none flex-col overflow-y-auto p-9">
  <div
    data-cy="editConnectionDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Edit Connection</div
  >

  <div class="flex flex-col text-base">
    <div class="mt-9 flex w-80 flex-row">
      <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Name</div>
      <div>
        {{ ref.data.connection.connectionId }}
      </div>
    </div>

    <div class="flex w-80 flex-row">
      <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Env</div>
      <div>
        {{ ref.data.connection.envId }}
      </div>
    </div>

    <div class="flex w-80 flex-row">
      <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Type</div>
      <div>
        {{ ref.data.connection.type }}
      </div>
    </div>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="editBigqueryForm"
      *ngIf="ref.data.connection.type === typeBigQuery"
    >
      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
          >Service Account Credentials</div
        >

        <div class="flex flex-col">
          <textarea
            rows="7"
            data-cy="editConnectionDialogBigqueryServiceAccountCredentialsInput"
            class="form-input border-s3 focus:border-m600 w-[400px] resize-none whitespace-nowrap rounded font-mono"
            [ngClass]="{
              'border-r600':
                editBigqueryForm.controls['serviceAccountCredentials']
                  .invalid &&
                editBigqueryForm.controls['serviceAccountCredentials'].touched
            }"
            formControlName="serviceAccountCredentials"
            placeholder="JSON"
          ></textarea>
          <m-validation
            [control]="editBigqueryForm.controls['serviceAccountCredentials']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
          >Query Size Limit, gb</div
        >

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogBigqueryQuerySizeLimitGbInput"
            class="form-input border-s3 focus:border-m600 w-80 rounded"
            [ngClass]="{
              'border-r600':
                editBigqueryForm.controls['bigqueryQuerySizeLimitGb'].invalid &&
                editBigqueryForm.controls['bigqueryQuerySizeLimitGb'].touched
            }"
            formControlName="bigqueryQuerySizeLimitGb"
            placeholder="Query Size Limit, gb (default: 1)"
          />
          <m-validation
            [control]="editBigqueryForm.controls['bigqueryQuerySizeLimitGb']"
          ></m-validation>
        </div>
      </div>
    </form>

    <!-- <form
      class="flex w-80 flex-col text-base"
      [formGroup]="editClickhouseForm"
      *ngIf="ref.data.connection.type === typeClickHouse"
    >
      <div>
        <div class="mb-6 flex flex-row items-center">
          <div class="w-[200px] flex-shrink-0 font-semibold">HTTPS</div>

          <div class="flex flex-col">
            <div
              class="flex max-w-min cursor-pointer flex-row items-center"
              (click)="toggleClickhouseSSL()"
            >
              <ui-switch
                class=""
                [checked]="isClickhouseSSL"
                color="#64BD63"
              ></ui-switch>
            </div>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Host</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogClickhouseHostInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  editClickhouseForm.controls['host'].invalid &&
                  editClickhouseForm.controls['host'].touched
              }"
              formControlName="host"
            />
            <m-validation
              [control]="editClickhouseForm.controls['host']"
            ></m-validation>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Port</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogClickhousePortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  editClickhouseForm.controls['port'].invalid &&
                  editClickhouseForm.controls['port'].touched
              }"
              formControlName="port"
            />
            <m-validation
              [control]="editClickhouseForm.controls['port']"
            ></m-validation>
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">User</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogClickhouseUserInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editClickhouseForm.controls['username'].invalid &&
                editClickhouseForm.controls['username'].touched
            }"
            formControlName="username"
          />
          <m-validation
            [control]="editClickhouseForm.controls['username']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Password</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogClickhousePasswordInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editClickhouseForm.controls['password'].invalid &&
                editClickhouseForm.controls['password'].touched
            }"
            formControlName="password"
            type="password"
          />
          <m-validation
            [control]="editClickhouseForm.controls['password']"
          ></m-validation>
        </div>
      </div>
    </form> -->

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="editMotherduckForm"
      *ngIf="ref.data.connection.type === typeMotherDuck"
    >
      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
          >MotherDuck Token</div
        >

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogMotherduckTokenInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editMotherduckForm.controls['motherduckToken'].invalid &&
                editMotherduckForm.controls['motherduckToken'].touched
            }"
            formControlName="motherduckToken"
          />
          <m-validation
            [control]="editMotherduckForm.controls['motherduckToken']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-start">
        <div class="mb-6 mt-3 w-[200px] flex-shrink-0 font-semibold"
          >Database</div
        >

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogMotherduckDatabaseInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editMotherduckForm.controls['database'].invalid &&
                editMotherduckForm.controls['database'].touched
            }"
            formControlName="database"
            placeholder="Optional"
          />
          <m-validation
            [control]="editMotherduckForm.controls['database']"
          ></m-validation>

          <div class="text-s400 mb-5 mt-2 h-[50px] text-base"
            >md:{{ editMotherduckForm.controls['database'].value }}?{{
              isMotherduckAttachModeSingle === true
                ? editMotherduckForm.controls['database'].value?.length > 0
                  ? 'attach_mode=single&'
                  : ''
                : ''
            }}saas_mode:true</div
          >
        </div>
      </div>

      <div
        class="mb-6 flex flex-row items-center"
        *ngIf="editMotherduckForm.controls['database'].value?.length > 0"
      >
        <div class="w-[200px] flex-shrink-0 font-semibold"
          >Attach Mode "single"</div
        >

        <div class="flex flex-col">
          <div
            class="flex max-w-min cursor-pointer flex-row items-center"
            (click)="toggleMotherduckAttachModeSingle()"
          >
            <ui-switch
              class=""
              [checked]="isMotherduckAttachModeSingle"
              color="#64BD63"
            ></ui-switch>
          </div>
        </div>
      </div>

      <div class="mb-6 flex flex-row items-center">
        <div class="w-[200px] flex-shrink-0 font-semibold"
          >Access Mode "READ_ONLY"</div
        >

        <div class="flex flex-col">
          <div
            class="flex max-w-min cursor-pointer flex-row items-center"
            (click)="toggleMotherduckAccessModeReadOnly()"
          >
            <ui-switch
              class=""
              [checked]="isMotherduckAccessModeReadOnly"
              color="#64BD63"
            ></ui-switch>
          </div>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="editPostgresForm"
      *ngIf="ref.data.connection.type === typePostgreSQL"
    >
      <div>
        <div class="mb-6 flex flex-row items-center">
          <div class="w-[200px] flex-shrink-0 font-semibold">SSL</div>

          <div class="flex flex-col">
            <div
              class="flex max-w-min cursor-pointer flex-row items-center"
              (click)="togglePostgresSSL()"
            >
              <ui-switch
                class=""
                [checked]="isPostgresSSL"
                color="#64BD63"
              ></ui-switch>
            </div>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Host</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogPostgresHostInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  editPostgresForm.controls['host'].invalid &&
                  editPostgresForm.controls['host'].touched
              }"
              formControlName="host"
            />
            <m-validation
              [control]="editPostgresForm.controls['host']"
            ></m-validation>
          </div>
        </div>

        <div class="mb-6 flex flex-row items-center">
          <div class="w-[200px] flex-shrink-0 font-semibold">Internal Host</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogPostgresInternalHostInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalHost"
              placeholder="Optional"
            />
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Port</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogPostgresPortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  editPostgresForm.controls['port'].invalid &&
                  editPostgresForm.controls['port'].touched
              }"
              formControlName="port"
            />
            <m-validation
              [control]="editPostgresForm.controls['port']"
            ></m-validation>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
            >Internal Port</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogPostgresInternalPortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalPort"
              placeholder="Optional"
            />
            <m-validation
              [control]="editPostgresForm.controls['internalPort']"
            ></m-validation>
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Database</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogPostgresDatabaseInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editPostgresForm.controls['database'].invalid &&
                editPostgresForm.controls['database'].touched
            }"
            formControlName="database"
          />
          <m-validation
            [control]="editPostgresForm.controls['database']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">User</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogPostgresUserInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editPostgresForm.controls['username'].invalid &&
                editPostgresForm.controls['username'].touched
            }"
            formControlName="username"
          />
          <m-validation
            [control]="editPostgresForm.controls['username']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Password</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogPostgresPasswordInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editPostgresForm.controls['password'].invalid &&
                editPostgresForm.controls['password'].touched
            }"
            formControlName="password"
            type="password"
          />
          <m-validation
            [control]="editPostgresForm.controls['password']"
          ></m-validation>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="editMysqlForm"
      *ngIf="ref.data.connection.type === typeMySQL"
    >
      <div>
        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Host</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogMysqlHostInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  editMysqlForm.controls['host'].invalid &&
                  editMysqlForm.controls['host'].touched
              }"
              formControlName="host"
            />
            <m-validation
              [control]="editMysqlForm.controls['host']"
            ></m-validation>
          </div>
        </div>

        <div class="mb-6 flex flex-row items-center">
          <div class="w-[200px] flex-shrink-0 font-semibold">Internal Host</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogMysqlInternalHostInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalHost"
              placeholder="Optional"
            />
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Port</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogMysqlPortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  editMysqlForm.controls['port'].invalid &&
                  editMysqlForm.controls['port'].touched
              }"
              formControlName="port"
            />
            <m-validation
              [control]="editMysqlForm.controls['port']"
            ></m-validation>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
            >Internal Port</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogMysqlInternalPortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalPort"
              placeholder="Optional"
            />
            <m-validation
              [control]="editMysqlForm.controls['internalPort']"
            ></m-validation>
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Database</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogMysqlDatabaseInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editMysqlForm.controls['database'].invalid &&
                editMysqlForm.controls['database'].touched
            }"
            formControlName="database"
          />
          <m-validation
            [control]="editMysqlForm.controls['database']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">User</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogMysqlUserInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editMysqlForm.controls['user'].invalid &&
                editMysqlForm.controls['user'].touched
            }"
            formControlName="user"
          />
          <m-validation
            [control]="editMysqlForm.controls['user']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Password</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogMysqlPasswordInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editMysqlForm.controls['password'].invalid &&
                editMysqlForm.controls['password'].touched
            }"
            formControlName="password"
            type="password"
          />
          <m-validation
            [control]="editMysqlForm.controls['password']"
          ></m-validation>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="editTrinoForm"
      *ngIf="ref.data.connection.type === typeTrino"
    >
      <div>
        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Server</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogTrinoServerInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  editTrinoForm.controls['server'].invalid &&
                  editTrinoForm.controls['server'].touched
              }"
              formControlName="server"
              placeholder="http(s)://hostname:port"
            />
            <m-validation
              [control]="editTrinoForm.controls['server']"
            ></m-validation>
          </div>
        </div>

        <div class="mb-6 flex flex-row items-center">
          <div class="w-[200px] flex-shrink-0 font-semibold"
            >Internal Server</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogTrinoInternalServerInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalServer"
              placeholder="Optional"
            />
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Catalog</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogTrinoCatalogInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editTrinoForm.controls['catalog'].invalid &&
                editTrinoForm.controls['catalog'].touched
            }"
            formControlName="catalog"
          />
          <m-validation
            [control]="editTrinoForm.controls['catalog']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Schema</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogTrinoSchemaInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editTrinoForm.controls['schema'].invalid &&
                editTrinoForm.controls['schema'].touched
            }"
            formControlName="schema"
          />
          <m-validation
            [control]="editTrinoForm.controls['schema']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">User</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogTrinoUserInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editTrinoForm.controls['user'].invalid &&
                editTrinoForm.controls['user'].touched
            }"
            formControlName="user"
          />
          <m-validation
            [control]="editTrinoForm.controls['user']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Password</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogTrinoPasswordInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editTrinoForm.controls['password'].invalid &&
                editTrinoForm.controls['password'].touched
            }"
            formControlName="password"
            type="password"
          />
          <m-validation
            [control]="editTrinoForm.controls['password']"
          ></m-validation>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="editPrestoForm"
      *ngIf="ref.data.connection.type === typePresto"
    >
      <div>
        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Server</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogPrestoServerInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  editPrestoForm.controls['server'].invalid &&
                  editPrestoForm.controls['server'].touched
              }"
              formControlName="server"
              placeholder="http(s)://hostname"
            />
            <m-validation
              [control]="editPrestoForm.controls['server']"
            ></m-validation>
          </div>
        </div>

        <div class="mb-6 flex flex-row items-center">
          <div class="w-[200px] flex-shrink-0 font-semibold"
            >Internal Server</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogPrestoInternalServerInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalServer"
              placeholder="Optional"
            />
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Port</div>

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogPrestoPortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  editPrestoForm.controls['port'].invalid &&
                  editPrestoForm.controls['port'].touched
              }"
              formControlName="port"
            />
            <m-validation
              [control]="editPrestoForm.controls['port']"
            ></m-validation>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
            >Internal Port</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogPrestoInternalPortInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              formControlName="internalPort"
              placeholder="Optional"
            />
            <m-validation
              [control]="editPrestoForm.controls['internalPort']"
            ></m-validation>
          </div>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Catalog</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogPrestoCatalogInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editPrestoForm.controls['catalog'].invalid &&
                editPrestoForm.controls['catalog'].touched
            }"
            formControlName="catalog"
          />
          <m-validation
            [control]="editPrestoForm.controls['catalog']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Schema</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogPrestoSchemaInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editPrestoForm.controls['schema'].invalid &&
                editPrestoForm.controls['schema'].touched
            }"
            formControlName="schema"
          />
          <m-validation
            [control]="editPrestoForm.controls['schema']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">User</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogPrestoUserInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editPrestoForm.controls['user'].invalid &&
                editPrestoForm.controls['user'].touched
            }"
            formControlName="user"
          />
          <m-validation
            [control]="editPrestoForm.controls['user']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Password</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogPrestoPasswordInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editPrestoForm.controls['password'].invalid &&
                editPrestoForm.controls['password'].touched
            }"
            formControlName="password"
            type="password"
          />
          <m-validation
            [control]="editPrestoForm.controls['password']"
          ></m-validation>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="editSnowflakeForm"
      *ngIf="ref.data.connection.type === typeSnowFlake"
    >
      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Account</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogSnowflakeAccountInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editSnowflakeForm.controls['account'].invalid &&
                editSnowflakeForm.controls['account'].touched
            }"
            formControlName="account"
          />
          <m-validation
            [control]="editSnowflakeForm.controls['account']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Warehouse</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogSnowflakeWarehouseInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editSnowflakeForm.controls['warehouse'].invalid &&
                editSnowflakeForm.controls['warehouse'].touched
            }"
            formControlName="warehouse"
          />
          <m-validation
            [control]="editSnowflakeForm.controls['warehouse']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Database</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogSnowflakeDatabaseInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editSnowflakeForm.controls['database'].invalid &&
                editSnowflakeForm.controls['database'].touched
            }"
            formControlName="database"
            placeholder="Optional"
          />
          <m-validation
            [control]="editSnowflakeForm.controls['database']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">User</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogSnowflakeUserInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editSnowflakeForm.controls['username'].invalid &&
                editSnowflakeForm.controls['username'].touched
            }"
            formControlName="username"
          />
          <m-validation
            [control]="editSnowflakeForm.controls['username']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Password</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogSnowflakePasswordInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editSnowflakeForm.controls['password'].invalid &&
                editSnowflakeForm.controls['password'].touched
            }"
            formControlName="password"
            type="password"
          />
          <m-validation
            [control]="editSnowflakeForm.controls['password']"
          ></m-validation>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="editDatabricksForm"
      *ngIf="ref.data.connection.type === typeDatabricks"
    >
      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Host</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogDatabricksHostInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editDatabricksForm.controls['host'].invalid &&
                editDatabricksForm.controls['host'].touched
            }"
            formControlName="host"
          />
          <m-validation
            [control]="editDatabricksForm.controls['host']"
          ></m-validation>
        </div>
      </div>

      <div class="mb-6 flex flex-row items-center">
        <div class="w-[200px] flex-shrink-0 font-semibold">Internal Host</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogDatabricksInternalHostInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            formControlName="internalHost"
            placeholder="Optional"
          />
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">HTTP Path</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogDatabricksPathInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editDatabricksForm.controls['path'].invalid &&
                editDatabricksForm.controls['path'].touched
            }"
            formControlName="path"
          />
          <m-validation
            [control]="editDatabricksForm.controls['path']"
          ></m-validation>
        </div>
      </div>

      <div class="mb-6 flex flex-row items-center">
        <div class="w-[200px] flex-shrink-0 font-semibold">Auth Type</div>

        <div class="flex flex-col">
          <ng-select
            #editConnectionDialogDatabricksAuthTypeSelect
            [fixNgSelectBottom]="editConnectionDialogDatabricksAuthTypeSelect"
            data-cy="editConnectionDialogDatabricksAuthTypeSelect"
            class="w-[400px] text-base"
            [items]="databricksAuthTypes"
            [clearable]="false"
            [searchable]="false"
            appendTo="body"
            formControlName="authType"
          ></ng-select>
        </div>
      </div>

      <ng-container
        *ngIf="
          editDatabricksForm.controls['authType'].value ===
          databricksAuthTypeOAuthM2M
        "
      >
        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
            >OAuth Client ID</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogDatabricksOauthClientIdInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  editDatabricksForm.controls['oauthClientId'].invalid &&
                  editDatabricksForm.controls['oauthClientId'].touched
              }"
              formControlName="oauthClientId"
            />
            <m-validation
              [control]="editDatabricksForm.controls['oauthClientId']"
            ></m-validation>
          </div>
        </div>

        <div class="flex flex-row items-center">
          <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
            >OAuth Client Secret</div
          >

          <div class="flex flex-col">
            <input
              autocomplete="off"
              spellcheck="false"
              data-cy="editConnectionDialogDatabricksOauthClientSecretInput"
              class="form-input border-s3 focus:border-m600 w-[400px] rounded"
              [ngClass]="{
                'border-r600':
                  editDatabricksForm.controls['oauthClientSecret'].invalid &&
                  editDatabricksForm.controls['oauthClientSecret'].touched
              }"
              formControlName="oauthClientSecret"
              type="password"
            />
            <m-validation
              [control]="editDatabricksForm.controls['oauthClientSecret']"
            ></m-validation>
          </div>
        </div>
      </ng-container>

      <div
        class="flex flex-row items-center"
        *ngIf="
          editDatabricksForm.controls['authType'].value ===
          databricksAuthTypePAT
        "
      >
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Token</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogDatabricksTokenInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editDatabricksForm.controls['token'].invalid &&
                editDatabricksForm.controls['token'].touched
            }"
            formControlName="token"
            type="password"
          />
          <m-validation
            [control]="editDatabricksForm.controls['token']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
          >Default Catalog</div
        >

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogDatabricksDefaultCatalogInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editDatabricksForm.controls['defaultCatalog'].invalid &&
                editDatabricksForm.controls['defaultCatalog'].touched
            }"
            formControlName="defaultCatalog"
            placeholder="Optional"
          />
          <m-validation
            [control]="editDatabricksForm.controls['defaultCatalog']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
          >Default Schema</div
        >

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogDatabricksDefaultSchemaInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editDatabricksForm.controls['defaultSchema'].invalid &&
                editDatabricksForm.controls['defaultSchema'].touched
            }"
            formControlName="defaultSchema"
            placeholder="Optional"
          />
          <m-validation
            [control]="editDatabricksForm.controls['defaultSchema']"
          ></m-validation>
        </div>
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="editApiForm"
      *ngIf="ref.data.connection.type === typeApi"
    >
      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Base URL</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogApiBaseUrlInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editApiForm.controls['baseUrl'].invalid &&
                editApiForm.controls['baseUrl'].touched
            }"
            formControlName="baseUrl"
            placeholder="https://example.com"
          />

          <m-validation
            [control]="editApiForm.controls['baseUrl']"
          ></m-validation>
        </div>
      </div>

      <div>
        <div class="mb-6 flex flex-row items-center">
          <div class="flex w-[200px] flex-shrink-0 font-semibold">Headers</div>
        </div>

        <div formArrayName="headers">
          <div class="flex flex-col">
            <div *ngFor="let header of apiGetHeaders().controls; let i = index">
              <div
                [formGroupName]="i"
                class="mb-6 flex w-[700px] flex-row items-center"
              >
                <button
                  class="text-s500 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  (click)="apiRemoveHeader(i)"
                >
                  <m-trash-icon></m-trash-icon>
                </button>

                <div class="ml-5 select-none">Key</div>

                <input
                  class="form-input border-s3 focus:border-m600 ml-5 w-[160px] rounded"
                  autocomplete="off"
                  spellcheck="false"
                  data-cy="editConnectionApiHeaderKeyInput"
                  formControlName="key"
                />

                <div class="ml-5 select-none">Value</div>

                <input
                  class="form-input border-s3 focus:border-m600 ml-5 w-full rounded"
                  autocomplete="off"
                  spellcheck="false"
                  data-cy="editConnectionApiHeaderValueInput"
                  formControlName="value"
                  placeholder="Will be empty after Save if not set"
                />
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          data-cy="editConnectionDialogApiAddHeaderButton"
          class="border-s400 text-s500 hover:bg-s100 h-11 flex-shrink-0 rounded border px-4 text-base leading-3 shadow-sm focus:outline-none"
          (click)="apiAddHeader()"
          >Add Header</button
        >
      </div>
    </form>

    <form
      class="flex w-80 flex-col text-base"
      [formGroup]="editGoogleApiForm"
      *ngIf="ref.data.connection.type === typeGoogleApi"
    >
      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold"
          >Service Account Credentials</div
        >

        <div class="flex flex-col">
          <textarea
            rows="7"
            data-cy="editConnectionDialogGoogleApiServiceAccountCredentialsInput"
            class="form-input border-s3 focus:border-m600 w-[400px] resize-none whitespace-nowrap rounded font-mono"
            [ngClass]="{
              'border-r600':
                editGoogleApiForm.controls['serviceAccountCredentials']
                  .invalid &&
                editGoogleApiForm.controls['serviceAccountCredentials'].touched
            }"
            formControlName="serviceAccountCredentials"
            placeholder="JSON"
          ></textarea>

          <m-validation
            [control]="editGoogleApiForm.controls['serviceAccountCredentials']"
          ></m-validation>
        </div>
      </div>

      <div class="flex flex-row items-center">
        <div class="mb-6 w-[200px] flex-shrink-0 font-semibold">Base URL</div>

        <div class="flex flex-col">
          <input
            autocomplete="off"
            spellcheck="false"
            data-cy="editConnectionDialogGoogleApiBaseUrlInput"
            class="form-input border-s3 focus:border-m600 w-[400px] rounded"
            [ngClass]="{
              'border-r600':
                editGoogleApiForm.controls['baseUrl'].invalid &&
                editGoogleApiForm.controls['baseUrl'].touched
            }"
            formControlName="baseUrl"
            placeholder="https://analyticsdata.googleapis.com"
          />

          <m-validation
            [control]="editGoogleApiForm.controls['baseUrl']"
          ></m-validation>
        </div>
      </div>

      <div>
        <div class="mb-6 flex flex-row items-center">
          <div class="flex w-[200px] flex-shrink-0 font-semibold">Scopes</div>
        </div>

        <div formArrayName="scopes">
          <div class="flex flex-col">
            <div *ngFor="let scopes of getScopes().controls; let i = index">
              <div
                [formGroupName]="i"
                class="mb-6 flex w-[700px] flex-row items-center"
              >
                <button
                  class="text-s500 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  (click)="removeScope(i)"
                >
                  <m-trash-icon></m-trash-icon>
                </button>

                <div class="ml-5 select-none">Scope</div>

                <input
                  class="form-input border-s3 focus:border-m600 ml-5 w-full rounded"
                  autocomplete="off"
                  spellcheck="false"
                  data-cy="editConnectionDialogGoogleApiScope"
                  formControlName="value"
                  placeholder="https://www.googleapis.com/auth/analytics.readonly"
                />
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          data-cy="editConnectionDialogGoogleApiAddScopeButton"
          class="border-s400 text-s500 hover:bg-s100 h-11 flex-shrink-0 rounded border px-4 text-base leading-3 shadow-sm focus:outline-none"
          (click)="addScope()"
          >Add Scope</button
        >
      </div>

      <div>
        <div class="mb-6 mt-6 flex flex-row items-center">
          <div class="flex w-[200px] flex-shrink-0 font-semibold">Headers</div>
        </div>

        <div class="text-s400 mb-6 w-[628px]"
          >No need to add more headers for this connection type. Authorization
          (Bearer token) and Content-Type (application/json) headers will be
          auto added. Authorization token will be obtained using the Service
          Account Credentials.
        </div>

        <div formArrayName="headers">
          <div class="flex flex-col">
            <div
              *ngFor="
                let header of googleApiGetHeaders().controls;
                let i = index
              "
            >
              <div
                [formGroupName]="i"
                class="mb-6 flex w-[700px] flex-row items-center"
              >
                <button
                  class="text-s500 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  (click)="googleApiRemoveHeader(i)"
                >
                  <m-trash-icon></m-trash-icon>
                </button>

                <div class="ml-5 select-none">Key</div>

                <input
                  class="form-input border-s3 focus:border-m600 ml-5 w-[160px] rounded"
                  autocomplete="off"
                  spellcheck="false"
                  data-cy="editConnectionDialogGoogleApiHeaderKeyInput"
                  formControlName="key"
                />

                <div class="ml-5 select-none">Value</div>

                <input
                  class="form-input border-s3 focus:border-m600 ml-5 w-full rounded"
                  autocomplete="off"
                  spellcheck="false"
                  data-cy="editConnectionDialogGoogleApiHeaderValueInput"
                  formControlName="value"
                  placeholder="Will be empty after Save if not set"
                />
              </div>
            </div>
          </div>
        </div>

        <button
          type="button"
          data-cy="editConnectionDialogGoogleApiAddHeaderButton"
          class="border-s400 text-s500 hover:bg-s100 h-11 flex-shrink-0 rounded border px-4 text-base leading-3 shadow-sm focus:outline-none"
          (click)="googleApiAddHeader()"
          >Add Header</button
        >
      </div>
    </form>

    <div class="mt-9 flex flex-row items-start">
      <button
        data-cy="editConnectionDialogSaveButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        (click)="save()"
        >Save</button
      >

      <button
        data-cy="editConnectionDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >

      <div class="flex flex-1"></div>

      <div
        *ngIf="
          ref.data.connection.type !== typeGoogleApi &&
          ref.data.connection.type !== typeApi
        "
        class="ml-5 flex flex-shrink-0 flex-col items-end gap-2"
      >
        <div class="flex h-[50px] flex-row items-center">
          <div
            *ngIf="testConnectionResult?.isSuccess === true"
            class="flex flex-shrink-0 items-center px-3 font-semibold text-green-600"
          >
            Connection is valid
          </div>

          <div
            *ngIf="testConnectionResult?.isSuccess === false"
            class="flex flex-shrink-0 items-center px-3 font-semibold text-red-500"
            [tp]="errorMessageTemplate"
          >
            Connection failed
          </div>

          <ng-template #errorMessageTemplate>
            <div class="break-words">{{
              !!testConnectionResult?.errorMessage
                ? testConnectionResult?.errorMessage
                : 'Error message is empty'
            }}</div>
          </ng-template>

          <button
            data-cy="editConnectionDialogTestConnectionButton"
            class="bg-m600 text-m0 ml-3 w-60 rounded py-3 text-base font-medium focus:outline-none"
            type="button"
            (click)="testConnection()"
            >Test Connection</button
          >
        </div>

        <div class="flex h-[50px] flex-row items-center">
          <div
            *ngIf="testInternalHostResult?.isSuccess === true"
            class="flex flex-shrink-0 items-center px-3 font-semibold text-green-600"
          >
            Internal is valid
          </div>

          <div
            *ngIf="testInternalHostResult?.isSuccess === false"
            class="flex flex-shrink-0 items-center px-3 font-semibold text-red-500"
            [tp]="internalErrorMessageTemplate"
          >
            Internal failed
          </div>

          <ng-template #internalErrorMessageTemplate>
            <div class="break-words">{{
              !!testInternalHostResult?.errorMessage
                ? testInternalHostResult?.errorMessage
                : 'Error message is empty'
            }}</div>
          </ng-template>

          <button
            data-cy="editConnectionDialogTestInternalHostButton"
            class="text-m0 ml-3 w-60 rounded py-3 text-base font-medium focus:outline-none"
            [ngClass]="
              isInternalFieldsComplete() ? 'bg-m600' : 'bg-s400 cursor-default'
            "
            type="button"
            [disabled]="!isInternalFieldsComplete()"
            (click)="testInternalHost()"
            >Test Internal Connection</button
          >
        </div>
      </div>
    </div>

    <div class="mt-2 flex h-6 flex-row items-center justify-end">
      <div
        *ngIf="isCurrentInternalPairInvalid()"
        class="text-sm font-semibold text-red-500"
      >
        {{ getInternalPairErrorMessage() }}
      </div>
    </div>
  </div>
</div>
